// @flow
import templateConst from 'app/common/lib/templateConst';

// Google One-Tap request errors: https://developers.google.com/identity/one-tap/web/retrieve-hints
export const CREDENTIAL_REQUEST_ERROR = {
  USER_CANCELED: 'userCanceled', // The user closed the hint selector.
  NO_CREDENTIALS_AVAILABLE: 'noCredentialsAvailable', // No hint available for the session.
  REQUEST_FAILED: 'requestFailed', // The request failed, most likely because of a timeout.
  OPERATION_CANCELED: 'operationCanceled', // The operation was programmatically canceled, do nothing.
  ILLEGAL_CONCURRENT_REQUEST: 'illegalConcurrentRequest', // Another operation is pending, this one was aborted.
  INITIALIZATION_ERROR: 'initializationError', // Failed to initialize.
  CONFIGURATION_ERROR: 'configurationError', // Configuration error.
};

export const GOOGLE_ACCOUNT_AUTH_METHOD = 'https://accounts.google.com';
export const GOOGLE_ID_AND_PASSWORD_AUTH_METHOD = 'googleyolo://id-and-password';

export const retrieveCredentials = (
  smartlock: any,
  mediated: boolean = true,
  authMethods: Array<string> = [GOOGLE_ACCOUNT_AUTH_METHOD],
) => {
  if (!smartlock) {
    return null;
  }

  const supportedMethodsAndProviders = {
    supportedAuthMethods: authMethods,
    supportedIdTokenProviders: [
      {
        uri: 'https://accounts.google.com',
        clientId: templateConst.settings.GPLUS_CLIENT_ID,
      },
    ],
    context: 'continue',
  };

  if (mediated) {
    return smartlock.hint(supportedMethodsAndProviders); // manual login/signup
  } else {
    return smartlock.retrieve(supportedMethodsAndProviders); // autologin/autosignup
  }
};

export const dismissIframe = (smartlock: any) => {
  if (smartlock && smartlock.cancelLastOperation) {
    smartlock.cancelLastOperation().then(() => {});
  }
};

// hides the prompt for v2 of Google One Tap
export const closeOneTap = (google: any) => {
  if (google && google.accounts && google.accounts.id) {
    google.accounts.id.cancel();
  }
};

export default undefined;
